import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getOtherAccountUser, updateUsersAndTeamsAdmin } from '../../../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';

function AddUserFromAnotherAcc(props) {
    const { t, i18n } = useTranslation();
    const [emailid, setemailid] = useState("");
    const [error, setError] = useState("");
    const [isloading, setIsLoading] = useState(false);
    const [userDetails, setuserDetails] = useState([]);
    const [isAdmin, setisAdmin] = useState(false);
    const navigate = useNavigate();

    async function handleSearch(e) {
        try {

            e.preventDefault();
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            if (validateField()) {
                setIsLoading(true);
                const serverResponsedata = await getOtherAccountUser(
                    siteid,
                    emailid,
                );
                setTimeout(() => {
                    setIsLoading(false);
                }, 2000);
                // if (!serverResponsedata.ok) {
                //     console.log("Network response was not ok");
                //     throw new Error("Network response was not ok");
                // } else {
                    const data = await serverResponsedata.json();
                    if (data.status == "success") {
                        console.log("Team members info " + JSON.stringify(data));
                        setuserDetails(data?.user_details ?? []);
                    } else {
                        if (data?.message?.errors) {
                            data.message.errors.forEach((err) => {
                                setError(err.message);
                            });
                        } else {
                            setError(data.message);
                        }
                    }
                // }

            }
        } catch (error) {
            console.error("[handleSearch] Error:", error);
            // Handle the error, show a user-friendly message or log it.
        }
    }

    function validateField() {
        if (emailid === "" || !emailid) {
            setError("Please Enter Email");
            return false;
        } else {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const result = regex.test(emailid);
            if (!result) {
                setError("Invalid Email");
                return false;

            }
        }
        return true;
    }

    async function handleSubmit(e) {
        e.preventDefault();

        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        const userDetail = userDetails.map((user) => ({
            userid: user.agentid,
            isadmin: isAdmin
        }));


        setIsLoading(true);
        let update = {
            reqid: 88,
            siteid: siteid,
            add_other_account_users: userDetail,
            teamid: props.teamInfo.team_id,
        }

        console.log("reques for delete user in DeleteUserandTeamAdmin   :::: " + JSON.stringify(update));
        let deleteFilter = await updateUsersAndTeamsAdmin(update);
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
        let deleteMsg = await deleteFilter.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/selectedteamsettings";
        } else if (deleteMsg.status == "success") {
            localStorage.setItem("s_message", deleteMsg.message);
            navigate("/selectedteamsettings", {
                state: { tab: "tab2", teamInfo: props.teamInfo },
            });


            window.location.reload();
        } else {
            if (deleteMsg.message?.errors) {
                deleteMsg.message.errors.forEach((err) => {
                    setError(err.message);

                });
            }
        }

    }


    return (
        <>
            <>
                <div>
                    <div className="tel-numbers">
                        <strong>{t("email_address")}</strong>
                    </div>
                    <div className="form pt-1 d-flex">
                        <input
                            type="text"
                            className="form-control  w-100"
                            value={emailid}
                            onChange={(e) => {
                                e.preventDefault();
                                setError("");
                                setemailid(e.target.value);
                                setuserDetails([]);
                            }}
                        />
                        <MDBBtn className="ms-2" onClick={(e) => handleSearch(e)}>Search</MDBBtn>

                    </div>
                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                    <div className="row pt-4">
                        {userDetails.map(user => (
                            <>
                                <div className="w-35">
                                    <strong>{t("User")}</strong>
                                    <p className="pt-1">{user.username}</p>
                                </div>
                                <div className="w-45">
                                    <strong>{t("Account")}</strong>
                                    <p className="pt-1">{user.account}</p>
                                </div>
                                <div className="w-20">
                                    <strong>{t("Is Admin")}</strong>
                                    <div>

                                        <label className="switch">
                                            <input
                                                className="form-control"
                                                type="checkbox"
                                                checked={isAdmin}
                                                onChange={(e) => setisAdmin(e.target.checked)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
                {userDetails && userDetails.length > 0 && (
                    <MDBModalFooter className="mt-2">
                        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                            {t("close")}
                        </MDBBtn>
                        <MDBBtn onClick={(e) => handleSubmit(e)}>{t("add")}</MDBBtn>
                    </MDBModalFooter>
                )}
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
            </>
        </>
    )
}

export default AddUserFromAnotherAcc
